import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { FaqComponent } from '../faq/faq.component';
import { ContactComponent } from '../contact/contact.component';
import { FaqService } from '../../services/faq.service';
import { FAQ } from '../../models/Faq';
import { UserService } from '../../../user/services/user.service';
import { startWith, Subscription } from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { DocumentationComponent } from "../documentation/documentation.component";

@Component({
  selector: 'app-main-help',
  standalone: true,
  imports: [
    CardModule,
    Tabs, TabList, Tab, TabPanels, TabPanel,
    TranslateModule,
    FaqComponent,
    ContactComponent,
    DocumentationComponent
],
  templateUrl: './main-help.component.html',
  styleUrls: ['./main-help.component.scss'],
  providers: [FaqService],
})
export class MainHelpComponent implements OnInit, OnDestroy {
  tabs: string[] = ['global.contact', 'global.documentation', 'global.faq' ];
  listFAQs: Array<FAQ> = [];
  currentUser: any;
  private langSub: Subscription;
  activeTab: number = 0;
  constructor(
    private readonly faqService: FaqService,
    private readonly translate: TranslateService,
    private readonly userService: UserService,
  ) {}

  ngOnInit() {
    this.currentUser = this.userService.getUser();

    const initialLang =
      this.currentUser.defaultLanguage.languageCode.toUpperCase();

    // Observable qui écoute la langue actuelle + ses changements
    this.langSub = this.translate.onLangChange
      .pipe(
        map((event) => event.lang.toUpperCase()),
        startWith(initialLang),
        distinctUntilChanged(), // évite d'appeler deux fois pour la même langue
        switchMap((lang) => {
          return this.faqService.getFAQ(lang);
        }),
      )
      .subscribe((faqs) => {
        this.listFAQs = faqs;
      });
  }

  ngOnDestroy() {
    this.langSub?.unsubscribe();
  }
}
